var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 38,
    viewBox: "0 0 33 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 38,
    fill: "url(#pattern0_49_48)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_49_48",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_49_48",
    transform: "matrix(0.0111111 0 0 0.00964912 0 0.0657895)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_49_48",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD+0lEQVR4nO2c2U4VQRCGB1FEY+KCJC5P4BbjteglMcaoCPENUK6MxgVvXOISxe011JcANe4RMV4R4w2u4AMIeOFnKjYJUbrnzJyZnp6mvoTkhKWq5qdT3V1V5ySJoiiKoiiKoiiKoiiKoiiK4gugDRgCvlEdX4GbEku0/3n+PmAo3ExihWpX8r98T2KFwEhihcBIYoXASGIE2Ex4bEpiAzhPeAwmsSCrBhgEZgmPWRPbpsV+uagL+S9BgV0u6kL2S5CuZE+XIKpnBhgGLgCHgS3AWmCZSWvyeqv52UVgxPxNpdRJ6DdAP7A6R8xrgGPAaFXB10HoUaA7c6D2+PcBY74fImShfwIngNaiRJ73DEuBk8B0k0fAc+aYmnpUDVXocWBH0QIv8Cw7gQ9FXWqM2AuSJ7iyeQ10FiVmA8+zDniWI86NC9jaYPvlPIGVyUtgVQMxtAJ7gbvAC2AK+GW+psz37gB7Gkk94hN4lTHW/26NJoUEL/Q40JHie4WpjfzIYHfK5NIVKbbXZ0wjg1nqNqEI/TMtJwNHgS9N+PgE9DWQs6ez1kPqtBmecPhbAtwoyM9v4LrYdPg7RQmEIPSoLY8akR+W4POBTWxz9HsXo9DdDl9FreSFuObwuz82od+k5OQykTTSa/HdAryNSeh+x+lCNq+ykc11pSWGgViEnrEViDy3t85aYlhbZPenSqGHHZeRLOfkZpl0bMaPYhD6gsW+3Ph802WJ5XIMQh+02L+Hf25bYumJQegtFvtSp/DNM0ss22IQusNi32d+nmPSUf+ovdBtFvtVzHnMWGJZXpQDFXoRCN1hsa+pw9Nm+Bz/PI15MzxksS+dEd8MWWI5EoPQFy32pf3km90xX1hGHFdwaT/5vILbatOPYykqrbH4kB6fL844uuNRFJVcZdJ2YILy+Wxr2sZUJhVGHX76THG+LMR2j6PwPxaT0MI+hy9ppJbFFYffA0U7C0HoMWmIOpqz0kgtmvspzdn3MQotnHT4W2JWdhFpRGxcTRk3OEMJhCL0tAyvpPjtbbKPOGHLyfN87GpywjR4oTHjWOtTfMtp5Kw5+zbKpFml7Sm2O4GPlERIQmMGDRsZcpR00iWdETMJOmnOvLPmtXzvltz4XGninyFHmWJlsQhd1dhu6YWsPIH54ENazi4Ck5NLSxfzyROcL6bNwOHSEgSWI9zpsja+ugk9xzszC9dSgMAt5jJS+Dk5BqHnkFm44zJBlDMPD1Txbqw6Cj3HrClfXjJzF9IF6TBv5mwzr7ebor3Uk5+E8Mb+OgpdS1RoT6jQAQstn0GhZONLHqH18zqycyOP0G1GbF3Z6cT/MZyKoiiKoiiKoiiKoiiKoihJU/wBFnHbBOvOCgsAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.f29861265192f0ed762782fa9d6e373a.svg";
export { ForwardRef as ReactComponent };